import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastFacade } from '@symphony-solo/domain/toast/src';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ErrorCode } from '@symphony-solo/shared/error-handling/src';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { TransactionReceiptService } from '../services/transaction-receipt.service';
import {
  getTransactionReceiptAction,
  getTransactionReceiptErrorAction,
  getTransactionReceiptSuccessAction,
} from './transaction-receipt.actions';

@Injectable()
export class TransactionReceiptEffects {
  constructor(
    private action$: Actions,
    private transactionReceiptService: TransactionReceiptService,
    private toastFacade: ToastFacade,
    private navController: NavController
  ) {}

  protected getTransactionRecept$ = createEffect(() =>
    this.action$.pipe(
      ofType(getTransactionReceiptAction),
      switchMap((payload) => {
        return this.transactionReceiptService.getTransactionReceipt(payload.seq).pipe(
          map((transactionReceipt) => {
            return getTransactionReceiptSuccessAction({
              transactionReceipt,
            });
          }),
          catchError(() => {
            const errorMessage = 'Could not get transaction receipt';
            this.toastFacade.showToastErrorMessage(errorMessage);

            const failures = new AppStateFailureBuilder()
              .setFailureType(FailureType.API)
              .addFailure(new AppStateFailureItemWithErrorCode(errorMessage, ErrorCode.CouldNotGetTransactionReceipt))
              .build();

            return of(getTransactionReceiptErrorAction({ failures }));
          })
        );
      })
    )
  );

  protected getTransactionReceiptError$ = createEffect(
    () => {
      return this.action$.pipe(
        ofType(getTransactionReceiptErrorAction),
        tap(() => {
          this.navController.pop();
        })
      );
    },
    { dispatch: false }
  );
}
